import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CustomButtonsModule } from '@shared/buttons';
import { ProjectActionsListComponent } from './project-actions-list/project-actions-list.component';
import { ApproveActionComponent } from './approve-action/approve-action.component';
import { RejectActionComponent } from './reject-action/reject-action.component';
import { SaveActionComponent } from './save-action/save-action.component';
import { ExitActionComponent } from './exit-action/exit-action.component';
import { DownloadLogActionComponent } from './download-log-action/download-log-action.component';
import { ExitActionService } from './exit-action/exit-action.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    TranslateModule,
    CustomButtonsModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    ApproveActionComponent,
    ProjectActionsListComponent,
    RejectActionComponent,
    SaveActionComponent,
    ExitActionComponent,
    DownloadLogActionComponent,
  ],
  exports: [ProjectActionsListComponent],
  providers: [ExitActionService],
})
export class ProjectActionsModule {}
